import type { ReactNode } from "react";
import styles from "./ListHeader.module.css";

interface ListHeaderProps {
  children: ReactNode;
  className?: string | undefined;
}

export function ListHeader({ children, className }: ListHeaderProps) {
  return (
    <h2 className={[styles.listHeader, className].filter(Boolean).join(" ")}>
      {children}
    </h2>
  );
}
